import '../styles.css';

import Icon from 'components/Shared/Icon';
import { toTop } from 'components/Shared/ScrollToTop';
import React from 'react';
import { connect } from 'react-redux';
import { hjTagging } from 'utils';

interface IState {
  url: string;
  button: string;
}

interface IProps {
  baseUrl: string;
}

class NotFound extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { url: '/', button: 'Voltar para a vitrine' };
  }

  componentDidMount() {
    toTop();
    document.body.style.overflow = 'hidden';
    hjTagging('ERRO-404');

    const courseHash = (/curso\/(.+)\/aula/gim.exec(window.location.href) || [])[1];

    if (!courseHash) return;
    this.setState({
      url: `/curso/${courseHash}`,
      button: 'Voltar para o curso',
    });
  }

  componentWillUnmount() {
    document.body.style.overflow = null;
  }

  render() {
    const { url, button } = this.state;
    const { baseUrl } = this.props;

    return (
      <div className='error-root'>
        <div>
          <div className='error-message'>
            <div className='error-title'>
              4<Icon name='icon-logo-nutror' />4
            </div>
            <div className='error-description'>
              <p>Não encontramos essa página.</p>
              <a href={baseUrl + url} className='link-button'>
                {button}
              </a>
              <p>
                Se você ficou com dúvidas, acesse nossa <a href={`${baseUrl}/help`}>Central de Ajuda</a> ou contate o{' '}
                <a href='mailto: suporte@eduzz.com'>suporte@eduzz.com</a>.
              </p>
            </div>
          </div>
          <div className='error-image'>
            <svg className='error-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 420 494'>
              <defs>
                <mask id='a' width='22.34' height='22.34' x='390.97' y='169.35' maskUnits='userSpaceOnUse'>
                  <path fill='#fff' d='M390.97 169.35h22.34v22.35h-22.34v-22.35z' />
                </mask>
                <mask id='b' width='22.34' height='22.34' x='10.3' y='100.46' maskUnits='userSpaceOnUse'>
                  <path fill='#fff' d='M10.3 100.46h22.35v22.34H10.3v-22.34z' />
                </mask>
              </defs>
              <g opacity='.2'>
                <path
                  fill='#0071bc'
                  d='M131.41 417.71a39.72 39.72 0 0 0-32.31 16.15l-8.73-.86A32.89 32.89 0 0 0 79 434.73a41 41 0 0 0-38.42-27.5A40.14 40.14 0 0 0 3.93 429.5a8.79 8.79 0 0 0 15.72 7.86 23.12 23.12 0 0 1 21-12.67 23.15 23.15 0 0 1 22.7 17.9 43.21 43.21 0 0 0-15.71 33.19 8.73 8.73 0 1 0 17.46 0 25.33 25.33 0 0 1 25.32-25.33 22.72 22.72 0 0 1 9.17 1.75l7.42 3.06 3.49-7.43a24 24 0 0 1 21-12.66A23.15 23.15 0 0 1 154.55 457l.87 11.79 10.91-3.93 6.11-.87a18.35 18.35 0 0 1 18.35 18.33v.44a8.73 8.73 0 0 0 8.73 8.74 8.3 8.3 0 0 0 8.72-7.85v-1.32a36.23 36.23 0 0 0-35.8-36.24h-2.18a40.61 40.61 0 0 0-38.85-28.38'
                />
                <path
                  fill='none'
                  d='M131.41 417.71a39.72 39.72 0 0 0-32.31 16.15l-8.73-.86A32.89 32.89 0 0 0 79 434.73a41 41 0 0 0-38.42-27.5A40.14 40.14 0 0 0 3.93 429.5a8.79 8.79 0 0 0 15.72 7.86 23.12 23.12 0 0 1 21-12.67 23.15 23.15 0 0 1 22.7 17.9 43.21 43.21 0 0 0-15.71 33.19 8.73 8.73 0 1 0 17.46 0 25.33 25.33 0 0 1 25.32-25.33 22.72 22.72 0 0 1 9.17 1.75l7.42 3.06 3.49-7.43a24 24 0 0 1 21-12.66A23.15 23.15 0 0 1 154.55 457l.87 11.79 10.91-3.93 6.11-.87a18.35 18.35 0 0 1 18.35 18.33v.44a8.73 8.73 0 0 0 8.73 8.74 8.3 8.3 0 0 0 8.72-7.85v-1.32a36.23 36.23 0 0 0-35.8-36.24h-2.18a40.61 40.61 0 0 0-38.85-28.38z'
                />
                <path
                  fill='#0071bc'
                  d='M417.8 469.66a40.61 40.61 0 0 0-40.6-38.42 41.5 41.5 0 0 0-27.51 10.48 46.73 46.73 0 0 0-40.16-22.27A48 48 0 0 0 265 450a48.89 48.89 0 0 0-38.86 29.25 8.73 8.73 0 0 0 4.8 11.35l3.5.88a8.75 8.75 0 0 0 7.86-5.24 30.1 30.1 0 0 1 28.37-19.21h7.86l1.31-7a31 31 0 0 1 29.69-23.58 30.13 30.13 0 0 1 30.12 30.13 27.8 27.8 0 0 1-1.31 8.73 8.74 8.74 0 0 0 5.66 10.95 8.3 8.3 0 0 0 10.66-4.89 7.24 7.24 0 0 0 .25-.79 37.35 37.35 0 0 0 2.18-14 33.4 33.4 0 0 0-.43-6.55 22.68 22.68 0 0 1 20.52-11.35 23.13 23.13 0 0 1 23.13 21.83 8.74 8.74 0 0 0 8.74 8.29h.43a8.73 8.73 0 0 0 8.3-9.14'
                />
                <path
                  fill='none'
                  d='M417.8 469.66a40.61 40.61 0 0 0-40.6-38.42 41.5 41.5 0 0 0-27.51 10.48 46.73 46.73 0 0 0-40.16-22.27A48 48 0 0 0 265 450a48.89 48.89 0 0 0-38.86 29.25 8.73 8.73 0 0 0 4.8 11.35l3.5.88a8.75 8.75 0 0 0 7.86-5.24 30.1 30.1 0 0 1 28.37-19.21h7.86l1.31-7a31 31 0 0 1 29.69-23.58 30.13 30.13 0 0 1 30.12 30.13 27.8 27.8 0 0 1-1.31 8.73 8.74 8.74 0 0 0 5.66 10.95 8.3 8.3 0 0 0 10.66-4.89 7.24 7.24 0 0 0 .25-.79 37.35 37.35 0 0 0 2.18-14 33.4 33.4 0 0 0-.43-6.55 22.68 22.68 0 0 1 20.52-11.35 23.13 23.13 0 0 1 23.13 21.83 8.74 8.74 0 0 0 8.74 8.29h.43a8.73 8.73 0 0 0 8.3-9.14z'
                />
                <path
                  fill='#0071bc'
                  d='M211.3 195.91a16.58 16.58 0 0 1 17 16.14v.89a17 17 0 0 1-17 17 17.46 17.46 0 0 1-17-17 17 17 0 0 1 17-17m0 51.52a34.5 34.5 0 1 0-34.49-34.49 34.49 34.49 0 0 0 34.49 34.49'
                />
                <path
                  fill='none'
                  d='M211.3 195.91a16.58 16.58 0 0 1 17 16.14v.89a17 17 0 0 1-17 17 17.46 17.46 0 0 1-17-17 17 17 0 0 1 17-17.03zm0 51.52a34.5 34.5 0 1 0-34.49-34.49 34.49 34.49 0 0 0 34.49 34.49z'
                />
                <path
                  fill='#0071bc'
                  d='M304.29 308.55l-28.82-26.19h.88l-2.19-2.62c1.31-4.37 2.19-8.3 3.06-12.66a214.92 214.92 0 0 0 3.49-28.82A91.52 91.52 0 0 1 296 249.18a47.59 47.59 0 0 1 8.29 59.37zm-75.09 29.26c-1.31 1.31-7.86 3.93-18.77 3.49s-17-3.93-18.34-5.68A184.81 184.81 0 0 1 172 296.33a102.13 102.13 0 0 0 78.58 0 220 220 0 0 1-21.38 41.48zm-110.45-29.26a46.71 46.71 0 0 1 8.25-59.81 75.62 75.62 0 0 1 14.84-10.92 173.61 173.61 0 0 0 3.93 29.69 58.07 58.07 0 0 0 2.62 11.79l-1.74 2.62h.43zM179 144a76.83 76.83 0 0 0 32.31 7 75.59 75.59 0 0 0 32.31-7 180.83 180.83 0 0 1 16.58 119.58c-.88 3.06-1.32 6.12-2.19 9.61a88.18 88.18 0 0 1-93.42 0c-.44-3.06-1.31-6.11-1.75-9.17A176.86 176.86 0 0 1 179 144zm32.3-45.46a216.41 216.41 0 0 1 23.57 30.13 58.94 58.94 0 0 1-47.15 0 256 256 0 0 1 23.58-30.13zm96.48 137.1a73.62 73.62 0 0 0-26.63-16.15C279.4 168 258 120.37 217.41 79.77l-6.11-6.11-6.11 6.11c-40.6 40.6-62 88.19-63.74 139.72a68.42 68.42 0 0 0-26.2 16.59 63.76 63.76 0 0 0-11.35 81.64 15.71 15.71 0 0 0 12.23 7.86h2.18a17 17 0 0 0 11.79-4.8L154.55 299a205.49 205.49 0 0 0 23.13 45.84c6.55 10 22.27 13.54 35.37 13.54h.43c7 0 23.14-1.31 30.13-10.92A229.75 229.75 0 0 0 268.05 299l24.45 21.83a17 17 0 0 0 11.79 4.8h2.18a17.43 17.43 0 0 0 12.66-7.86 65.93 65.93 0 0 0-11.35-82.13z'
                />
                <path
                  fill='none'
                  d='M304.29 308.55l-28.82-26.19h.88l-2.19-2.62c1.31-4.37 2.19-8.3 3.06-12.66a214.92 214.92 0 0 0 3.49-28.82A91.52 91.52 0 0 1 296 249.18a47.59 47.59 0 0 1 8.29 59.37zm-75.09 29.26c-1.31 1.31-7.86 3.93-18.77 3.49s-17-3.93-18.34-5.68A184.81 184.81 0 0 1 172 296.33a102.13 102.13 0 0 0 78.58 0 220 220 0 0 1-21.38 41.48zm-110.45-29.26a46.71 46.71 0 0 1 8.25-59.81 75.62 75.62 0 0 1 14.84-10.92 173.61 173.61 0 0 0 3.93 29.69 58.07 58.07 0 0 0 2.62 11.79l-1.74 2.62h.43zM179 144a76.83 76.83 0 0 0 32.31 7 75.59 75.59 0 0 0 32.31-7 180.83 180.83 0 0 1 16.58 119.58c-.88 3.06-1.32 6.12-2.19 9.61a88.18 88.18 0 0 1-93.42 0c-.44-3.06-1.31-6.11-1.75-9.17A176.86 176.86 0 0 1 179 144zm32.3-45.46a216.41 216.41 0 0 1 23.57 30.13 58.94 58.94 0 0 1-47.15 0 256 256 0 0 1 23.58-30.13zm96.48 137.1a73.62 73.62 0 0 0-26.63-16.15C279.4 168 258 120.37 217.41 79.77l-6.11-6.11-6.11 6.11c-40.6 40.6-62 88.19-63.74 139.72a68.42 68.42 0 0 0-26.2 16.59 63.76 63.76 0 0 0-11.35 81.64 15.71 15.71 0 0 0 12.23 7.86h2.18a17 17 0 0 0 11.79-4.8L154.55 299a205.49 205.49 0 0 0 23.13 45.84c6.55 10 22.27 13.54 35.37 13.54h.43c7 0 23.14-1.31 30.13-10.92A229.75 229.75 0 0 0 268.05 299l24.45 21.83a17 17 0 0 0 11.79 4.8h2.18a17.43 17.43 0 0 0 12.66-7.86 65.93 65.93 0 0 0-11.35-82.13z'
                />
                <path
                  fill='#0071bc'
                  d='M211.3 382.34a8.73 8.73 0 0 0-8.73 8.73v28.38a8.73 8.73 0 1 0 17.46 0v-28.38a8.73 8.73 0 0 0-8.73-8.73'
                />
                <path
                  fill='none'
                  d='M211.3 382.34a8.73 8.73 0 0 0-8.73 8.73v28.38a8.73 8.73 0 1 0 17.46 0v-28.38a8.73 8.73 0 0 0-8.73-8.73z'
                />
                <path
                  fill='#0071bc'
                  d='M261.07 399.37v-20.52a8.73 8.73 0 0 0-8.73-8.73 8.28 8.28 0 0 0-8.73 7.83 6.76 6.76 0 0 0 0 .9v20.52a8.28 8.28 0 0 0 7.83 8.73 6.76 6.76 0 0 0 .9 0 8.73 8.73 0 0 0 8.73-8.73'
                />
                <path
                  fill='none'
                  d='M261.07 399.37v-20.52a8.73 8.73 0 0 0-8.73-8.73 8.28 8.28 0 0 0-8.73 7.83 6.76 6.76 0 0 0 0 .9v20.52a8.28 8.28 0 0 0 7.83 8.73 6.76 6.76 0 0 0 .9 0 8.73 8.73 0 0 0 8.73-8.73z'
                />
                <path fill='#0071bc' d='M179.43 399.37v-20.52a8.73 8.73 0 0 0-17.46 0v20.52a8.73 8.73 0 0 0 17.46 0' />
                <path fill='none' d='M179.43 399.37v-20.52a8.73 8.73 0 0 0-17.46 0v20.52a8.73 8.73 0 0 0 17.46 0z' />
                <path
                  fill='#0071bc'
                  d='M404 38.33c-1.95-4.33-15-3.33-34 1.84a52.16 52.16 0 0 0-87-21.08h29.91a9.65 9.65 0 1 1 0 19.3H271a51.55 51.55 0 0 0-1.76 6.42h27.05a9.66 9.66 0 1 1 0 19.31H269a48 48 0 0 0 1.55 6.42h42.37a9.72 9.72 0 0 1 9.08 6.25l-1.81.75q-2.45 1-4.85 2c-5.4 2.17-10.58 4.13-15.43 5.86s-9.36 3.21-13.45 4.44h-4.81c.34.37.69.73 1 1.09l-1.81.49c-7.49 2-12.89 2.77-15.28 2.1a1.84 1.84 0 0 1-1.28-.89 1.37 1.37 0 0 1 0-1 4.68 4.68 0 0 1 .83-1.47c1.46-1.85 4.58-4.32 9-7.22a.17.17 0 0 1 0-.07c-.05-.21-.09-.42-.13-.63l-.09-.45-.09-.46-.46.27c-5 3-9.4 5.89-13.11 8.58-9.49 6.89-14.46 12.55-13 15.79 2.27 5.2 20.54 2.7 45.65-5.32l1.62-.53.34.21a52.19 52.19 0 0 0 76-32.75c.07-.29.13-.59.2-.88 21.73-12.31 35.12-23.33 32.96-28.37zm-31.89 13.36a50.09 50.09 0 0 0-1.65-9.94c1.26-.27 2.44-.51 3.52-.7 4.09-.7 6.89-.72 8 .05l.07.06a1.37 1.37 0 0 1 .22.19 1.17 1.17 0 0 1 .19.3c.81 1.77-3.13 5.35-10.35 10.04z'
                />
              </g>
              <g mask='url(#a)'>
                <path
                  fill='#28ce52'
                  d='M393.31 178.19h5.33a1.16 1.16 0 0 0 1.16-1.19v-5.2a2.42 2.42 0 0 1 2.22-2.46 2.33 2.33 0 0 1 2.46 2.33V177a1.16 1.16 0 0 0 1.16 1.17h5.2a2.43 2.43 0 0 1 2.47 2.21 2.33 2.33 0 0 1-2.33 2.46h-5.34a1.17 1.17 0 0 0-1.16 1.17v5.2a2.42 2.42 0 0 1-2.21 2.46 2.33 2.33 0 0 1-2.47-2.33V184a1.17 1.17 0 0 0-1.16-1.17h-5.2a2.42 2.42 0 0 1-2.47-2.21 2.33 2.33 0 0 1 2.34-2.46'
                />
              </g>
              <path
                fill='#28ce52'
                d='M20.4 260.82h5.33a1.16 1.16 0 0 0 1.16-1.16v-5.2A2.43 2.43 0 0 1 29.1 252a2.34 2.34 0 0 1 2.47 2.33v5.34a1.16 1.16 0 0 0 1.16 1.16h5.2A2.43 2.43 0 0 1 40.4 263a2.34 2.34 0 0 1-2.34 2.47h-5.33a1.16 1.16 0 0 0-1.16 1.16v5.2a2.43 2.43 0 0 1-2.21 2.47 2.34 2.34 0 0 1-2.47-2.3v-5.33a1.16 1.16 0 0 0-1.16-1.16h-5.2a2.43 2.43 0 0 1-2.47-2.22 2.34 2.34 0 0 1 2.34-2.46M354.15 20.89v-5.33a1.16 1.16 0 0 0-1.15-1.17h-5.2a2.43 2.43 0 0 1-2.47-2.21 2.34 2.34 0 0 1 2.34-2.46H353a1.17 1.17 0 0 0 1.16-1.17v-5.2a2.44 2.44 0 0 1 2.21-2.47 2.34 2.34 0 0 1 2.46 2.34v5.33A1.17 1.17 0 0 0 360 9.72h5.2a2.42 2.42 0 0 1 2.47 2.21 2.33 2.33 0 0 1-2.33 2.46H360a1.16 1.16 0 0 0-1.16 1.17v5.2a2.42 2.42 0 0 1-2.21 2.46 2.34 2.34 0 0 1-2.47-2.33'
              />
              <g mask='url(#b)'>
                <path
                  fill='#28ce52'
                  d='M12.64 109.29H18a1.16 1.16 0 0 0 1.17-1.16v-5.2a2.43 2.43 0 0 1 2.21-2.47 2.34 2.34 0 0 1 2.47 2.34v5.33a1.16 1.16 0 0 0 1.15 1.16h5.2a2.44 2.44 0 0 1 2.47 2.22 2.35 2.35 0 0 1-2.36 2.49H25a1.16 1.16 0 0 0-1.16 1.16v5.2a2.43 2.43 0 0 1-2.22 2.47 2.33 2.33 0 0 1-2.46-2.33v-5.34A1.16 1.16 0 0 0 18 114h-5.22a2.42 2.42 0 0 1-2.47-2.21 2.34 2.34 0 0 1 2.33-2.47'
                />
              </g>
              <path
                fill='#28ce52'
                d='M89.21 204.75h1.14a1.48 1.48 0 0 0 1.48-1.48v-1.14a.95.95 0 1 1 1.89 0v1.14a1.48 1.48 0 0 0 1.48 1.48h1.15a.95.95 0 0 1 0 1.89H95.2a1.48 1.48 0 0 0-1.48 1.48v1.14a.95.95 0 1 1-1.89 0v-1.14a1.48 1.48 0 0 0-1.48-1.48h-1.14a.95.95 0 1 1 0-1.89M214.57 35.35a3.22 3.22 0 1 1 3.21 3.21 3.22 3.22 0 0 1-3.21-3.21M308.66 151.05a3.22 3.22 0 1 1-3.21 3.22 3.22 3.22 0 0 1 3.21-3.22M125.66 94.3A1.66 1.66 0 1 1 124 96a1.66 1.66 0 0 1 1.65-1.66M90.62 5.61A1.66 1.66 0 1 1 89 7.27a1.66 1.66 0 0 1 1.66-1.66'
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  baseUrl: state.template.base.subdomain ? '' : '/v3',
});

export default connect(mapStateToProps, {})(NotFound);
